import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { NavLink } from 'react-router-dom';
import { useGlobalState } from '../../../stateProviders/GlobalStateProvider';

export const TabNavigation = () => {
	const globalState = useGlobalState();

	const navigationTabConfig = React.useMemo(() => {
		const tabs = [
			{
				name: 'Company Profile',
				path: 'profile',
			},
			{
				name: 'Logistic Costs',
				path: 'logistics',
			},
			{
				name: 'Additional Costs',
				path: 'additional-costs',
			},
			{
				name: 'Accessories',
				path: 'accessories',
			},
			{
				name: 'Discounts and Profit Settings',
				path: 'discounts-profit',
			},
			// {
			//     name: 'Proposal',
			//     path: 'proposal',
			// },
			{
				name: 'Financing Plans',
				path: 'financing',
			},
			{
				name: 'Configuration',
				path: 'config',
				roleWhiteList: ['Super Admin'],
			},
		];
		return tabs;
	}, []);

	const filteredTabs = navigationTabConfig.filter((tab) => {
		if (tab.roleWhiteList?.length) {
			if (!globalState?.appUser?.role.roleName) return false;
			return tab.roleWhiteList.includes(globalState?.appUser?.role.roleName);
		}
		return true;
	});

	const [value, setValue] = React.useState(0);
	const locationPath = window.location.pathname.split('/').pop();
	React.useEffect(() => {
		const idx = filteredTabs.findIndex((tab) => tab.path === locationPath);
		if (idx !== -1) setValue(idx);
	}, [locationPath, filteredTabs]);

	const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
			<Tabs
				value={value}
				onChange={handleChange}
				aria-label="nav tabs example"
				role="navigation"
				variant="scrollable"
				scrollButtons={false}
			>
				{filteredTabs.map((tab, idx) => (
					<Tab
						key={tab.path}
						label={tab.name}
						component={NavLink}
						to={tab.path}
						value={idx}
					/>
				))}
			</Tabs>
		</Box>
	);
};
